import VAContainer from './VAContainer'

export default VAContainer
